import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

const TONE_ICON = {
  neutral: "text-muted-2",
  danger: "text-error",
  warning: "text-warning",
} as const;

/** Estado vazio / erro / sem acesso — centralizado na área de conteúdo. */
export function StateMessage({
  icon,
  title,
  description,
  action,
  tone = "neutral",
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  tone?: "neutral" | "danger" | "warning";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex min-h-[40vh] flex-col items-center justify-center gap-3 px-6 text-center",
        className,
      )}
    >
      {icon && (
        <div
          className={cn(
            "mb-1 grid size-14 place-items-center rounded-md border border-border bg-ov-1",
            TONE_ICON[tone],
          )}
        >
          {icon}
        </div>
      )}
      <h3 className="text-h-md font-semibold tracking-heading text-fg">{title}</h3>
      {description && (
        <div className="max-w-md text-body-sm leading-normal text-muted">{description}</div>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
